import $ from 'jquery';
import 'popper.js';
import 'bootstrap';
import 'jquery-ui';

require('../plugins/jquery-linedtextarea.min.js');
require("../plugins/daterangepicker.js");
require("../plugins/requirement-markers.js");
require('slick-carousel-latest/slick/slick');
import '/webpack-assets/js/plugins/custom-select';
import 'slick-carousel-latest/slick/slick.scss';
//import { disablePageScroll, enablePageScroll } from 'scroll-lock';
const adaptive = $(window).width() < 768;


// jquery elements
var $wysiTextArea = $("textarea.wysi");
var $tagsInput = $(".tagsinput");
var $datepicker = $(".datepicker");
var $dateTimePicker = $(".datetimepicker");
var $textAreaAutoHeight = $(".textarea-auto-height");
var $hoverBlock = $(".hover-block");
var $footerPaymentsSlider = $('.footer-inner__payments-logos');

// DOM elements
var btnAccordion = document.getElementsByClassName("btn-accordion");

// booleans
let update = true;

// timeouts
let notificationTimerID = function () { }

window.setCookie = function (name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
};

window.getCookie = function (name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

export function checkIsElement($container) {
    return $container.length !== 0;
}

function initSelectmenu() {
    $(".custom-select").customSelect2();
}

function tabsSlider() {
    if ($("*").is(".tabs-slider")) {
        $(".tabs-slider").slick({
            appendArrows: $(".offer-page .items-slider .slider__nav"),
            autoplaySpeed: 10000,
            adaptiveHeight: false,
            speed: 500,
            arrows: true,
            infinite: false,

            responsive: [
                {
                    breakpoint: 3000,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 680,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 592,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });
    }
}

function initSpan() {
    $(".checkbox-group .checkbox-body .checkbox label").each(function () {
        var html = $(this).html() + "<span></span>";
        $(this).html(html);
    });

    $(".radiobox-group .radiobox-body label").each(function () {
        var html = $(this).html() + "<span></span>";
        $(this).html(html);
    });

    $(".js-radiobox-group .radiobox-body label").each(function () {
        var html = $(this).html() + "<span></span>";
        $(this).html(html);
    });
}

function renderAlert(text, colorClass, duration, undo = '') {
    const alertId = `alert-${new Date().getTime()}`;
    const alertHtml = `
        <div id="${alertId}" class="custom-alerts" style="display: none">
            <div class="${colorClass} alert">
                <img class="custom-alert-img" src="/img/notifications/${colorClass}.svg" alt="${colorClass}">
                <div class="custom-alert-label">
                    ${text}
                    ${undo}
                </div>
                <button type="button" class="close close-alert">×</button>
            </div>
        </div>
    `;

    $('body').append(alertHtml);
    $(`#${alertId}`).show();
    $('#' + alertId).css('bottom', '50px');
    setTimeout(function(){
        $('#' + alertId).css('bottom', '-100px');
        setTimeout(()=>{
            $(this).remove();
        }, 500)
    }, duration)
}

function cc_format(value) {
    var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
    var matches = v.match(/\d{4,16}/g);
    var match = matches && matches[0] || ''
    var parts = []

    for (var i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4))
    }

    if (parts.length) {
        return parts.join(' ')
    } else {
        return value
    }
}

function textAreaAdjust(o) {
    o[0].style.height = "1px";
    o[0].style.height = 0 + o[0].scrollHeight + "px";
}

function showDropDownOnHover() {
    var drdItems = $(".nav-admin").find(".dropdown");
    if (!drdItems.length) return;

    drdItems.mouseenter(function () {
        if (!drdItems.hasClass("open")) {
            $(this).find(".dropdown-toggle").click();
        }
    });

    drdItems.mouseleave(function () {
        if (drdItems.hasClass("open")) {
            $(this).find(".dropdown-toggle").click();
        }
    });
}

function initDateRangePicker() {
    if ($('.datePicker').length > 0) {
        dataRangePickSetting.singleDatePicker = true;
        dataRangePickSetting.ranges = false;

        $(".datePicker").daterangepicker(
            dataRangePickSetting,
            function (start, end, label) {
                $(".datePicker").val(start.format("MM/DD/YYYY"));
                $(".datePicker").trigger("change");
            }
        );

        if (adaptive) {
            $(".datePicker").daterangepicker(
                dataRangePickSetting,
                function (start, end, label) {
                    $(".datePicker").val(start.format("MM/DD/YYYY"));
                    $(".datePicker").trigger("change");
                }
            );
            $(".drp-calendar.right").hide();
            $(".daterangepicker .drp-selected").hide();
            $(".drp-calendar.left").addClass("single");

            $(".calendar-table").on("DOMSubtreeModified", function () {
                var el = $(".prev.available").parent().children().last();
                if (el.hasClass("next available")) {
                    return;
                }
                el.addClass("next available");
                el.append("<span></span>");
            });
        }
    }

    if ($('.datepicker-range').length > 0) {
        dataRangePickSetting.singleDatePicker = false;
        dataRangePickSetting.showDropdowns = true;
        dataRangePickSetting.alwaysShowCalendars = false;
        dataRangePickSetting.ranges = true;

        $(".datepicker-range").daterangepicker(
            dataRangePickSetting,
            function (start, end, label) {
                $(".datepicker-range").val(
                    start.format("MM/DD/YYYY") + " - " + end.format("MM/DD/YYYY")
                );
                $(".datepicker-range").trigger("change");
            }
        );
    }

    if ($('.datepicker-range-second').length > 0) {
        dataRangePickSetting.singleDatePicker = false;
        dataRangePickSetting.showDropdowns = true;
        dataRangePickSetting.alwaysShowCalendars = false;
        dataRangePickSetting.ranges = true;

        $(".datepicker-range-second").daterangepicker(
            dataRangePickSetting,
            function (start, end, label) {
                $(".datepicker-range-second").val(
                    start.format("MM/DD/YYYY") + " - " + end.format("MM/DD/YYYY")
                );
                $(".datepicker-range-second").trigger("change");
            }
        );
    }
}

function toggleTab($container) {
    if (!checkIsElement($container)) return false;

    var tab = $container.find(".tab");

    tab.click(function () {
        if (!$(this).hasClass("active")) {
            tab.removeClass("active");
            $(this).addClass("active");
        }
    });
}

function initNavBarSubMenu($handleElemSelector) {
    if (!checkIsElement($handleElemSelector)) return false;

    var subMenu = $handleElemSelector.find(".js-sub-menu");
    var subMenuItem = null;
    var VISIBLE_COUNT = 10;

    subMenu.each(function () {
        subMenuItem = $(this).find(".js-sub-menu-item");
        if (subMenuItem.length > VISIBLE_COUNT) {
            subMenuItem.each(function (i) {
                if (i >= VISIBLE_COUNT) {
                    $(this).hide();
                }
            });
            $(this).find(".js-sub-menu-view-all").parent().show();
        } else {
            $(this).find(".js-sub-menu-view-all").parent().hide();
        }
    });
}

function getFile() {
    var $input = $(this);
    var filePlaceholder = $("<div>", {
        class: "file",
        html: $("<span>", {
            class: "attached-doc",
        }),
    }).append(this.files[0].name);
    var removeBtn = $("<div>", {
        class: "file-remove",
        click: function () {
            $(this).closest(".file-area").children().remove();
            $input.val("");
        },
    });
    var fileArea = $(".file-area");

    removeBtn.appendTo(filePlaceholder);

    fileArea.children().remove();

    fileArea.append(filePlaceholder);
}

function initShoppingCart($handleElemSelector) {
    if (!checkIsElement($handleElemSelector)) return false;

    initCharacterInfoBlock();

    function initCharacterInfoBlock() {
        var infoBlock = $(".character-info-block");
        if (!checkIsElement(infoBlock)) return false;

        var checkoutBtn = $("#cartCheckoutBtn");

        checkoutBtn.click(function (ev) {
            ev.preventDefault();

            $(".character-info-block input").each(function () {
                if (
                    $(this).is("#character-name") ||
                    $(this).is("#fifa-email") ||
                    $(this).is("#fifa-password") ||
                    $(this).is("#backup-code-1") ||
                    $(this).is("#backup-code-2") ||
                    $(this).is("#backup-code-3")
                ) {
                    if ($(this).val().trim().trim() === "") {
                        var scrollTop = $(this).offset().top;
                        var headerHeight = parseInt($(".js-get-header-heigth").height());
                        $(document).scrollTop(scrollTop - headerHeight);
                        return false;
                    }
                }
            });

            var infoBlockForm = $(".character-info-block").find("form");
            if (checkout(infoBlockForm)) {
                //tagTracking("checkout");
                location.assign($(this).attr("href"));
            }
        });
    }

    function checkout(form) {
        var state = [];

        form.each(function () {
            if ($(this).find(".cart-item-nick").is("input")) {
                if ($(this).find(".cart-item-nick").val().trim() === "") {
                    $(this).find(".cart-item-nick").addClass("error");
                    state.push(false);
                } else {
                    $(this).find(".cart-item-nick").removeClass("error");
                    state.push(true);
                }
            }

            if ($(this).find(".cart-fifa-email").is("input")) {
                if ($(this).find(".cart-fifa-email").val().trim() === "") {
                    $(this).find(".cart-fifa-email").addClass("error");
                    state.push(false);
                } else {
                    $(this).find(".cart-fifa-email").removeClass("error");
                    state.push(true);
                }
            }

            if ($(this).find(".cart-fifa-password").is("input")) {
                if ($(this).find(".cart-fifa-password").val().trim() === "") {
                    $(this).find(".cart-fifa-password").addClass("error");
                    state.push(false);
                } else {
                    $(this).find(".cart-fifa-password").removeClass("error");
                    state.push(true);
                }
            }

            if ($(this).find(".cart-backup-code-1").is("input")) {
                if ($(this).find(".cart-backup-code-1").val().trim() === "") {
                    $(this).find(".cart-backup-code-1").addClass("error");
                    state.push(false);
                } else {
                    $(this).find(".cart-backup-code-1").removeClass("error");
                    state.push(true);
                }
            }

            if ($(this).find(".cart-backup-code-2").is("input")) {
                if ($(this).find(".cart-backup-code-2").val().trim() === "") {
                    $(this).find(".cart-backup-code-2").addClass("error");
                    state.push(false);
                } else {
                    $(this).find(".cart-backup-code-2").removeClass("error");
                    state.push(true);
                }
            }

            if ($(this).find(".cart-backup-code-3").is("input")) {
                if ($(this).find(".cart-backup-code-3").val().trim() === "") {
                    $(this).find(".cart-backup-code-3").addClass("error");
                    state.push(false);
                } else {
                    $(this).find(".cart-backup-code-3").removeClass("error");
                    state.push(true);
                }
            }
        });

        return state.indexOf(false) === -1;
    }
}

function checkAlert() {
    var alerts = $(document).find(".alert");
    var timeout = 10000;

    if (alerts.length) {
        alerts.each(function () {
            if (!$(this).is(".alert-danger")) {
                if ($(this).is(".alert-warning")) {
                    timeout = 20000;
                } else {
                    timeout = 10000;
                }
                closeAlert($(this), timeout);
            }
        });
    }

    function closeAlert(alert, timeout) {
        setTimeout(function () {
            alert.find("button.close").trigger("click");
        }, timeout);
    }
}

function requestForSearchHeaderInput(input) {
    let value = input.val();
    if (parseInt(value.length) > 2) {
        const categoryId = input.closest('.header-search__wrap--group').find('.header-search__filter-chips-name').attr('data-category-search')
        var request = {
            name: value,
            "per-page": 20,
            ajax: 1,
        };

        if (categoryId) {
            request["category_id"] = categoryId;
        }

        $.ajax({
            url: $(input).attr("data-url"),
            data: request,
            success: function (data) {
                $('.js-filter-search-desc').removeClass('active');
                $('.header-search__fiters-wrap').removeClass('active');
                $(".search-result").addClass('active');
                $(".search-result").html(data);
                $('.js-category-mob').removeClass('active');
                $('body').addClass('modal-open');
                $('.background-page').addClass('active');
                $('.js-header-search-filter-mob').removeClass('active');
                $('.js-filters-mobile').removeClass('active');
            },
        });
    } else {
        $(".search-result").removeClass('active');
    }
}


function validateEmptyInput($form) {
    $form.find('input[type="text"]').each(function () {
        if ($(this).val().length === 0) {
            $(this).addClass("error");
        } else {
            $(this).removeClass("error");
        }
    });
}

var Go2Top = (function () {
    var handle = function () {
        var currentWindowPosition = $(window).scrollTop();
        if (currentWindowPosition > 300) {
            $(".go2top").show();
        } else {
            $(".go2top").hide();
        }
    };

    return {
        init: function () {
            handle();

            if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
                $(window).bind("touchend touchcancel touchleave", function (e) {
                    handle();
                });
            } else {
                $(window).scroll(function () {
                    handle();
                });
            }

            $(".go2top").on("click", function (e) {
                e.preventDefault();
                $("html, body").animate(
                    {
                        scrollTop: 0,
                    },
                    600
                );
            });
        },
    };
})();

function CopyToClipboard(containerid) {
    var copytext = document.createElement("input");
    copytext.value = $("#" + containerid).html();
    document.body.appendChild(copytext);
    copytext.select();
    document.execCommand("copy");
    document.body.removeChild(copytext);
}

window.showOldModalCart = function(isShow) {
    if(isShow) {
        $('#cardModal').modal('show');
    } else {
        $("#cardModal").modal("hide");
    }
}

function getCaret(el) {
    if (el.selectionStart) {
        return el.selectionStart;
    } else if (document.selection) {
        el.focus();
        var r = document.selection.createRange();
        if (r == null) {
            return 0;
        }
        var re = el.createTextRange(),
            rc = re.duplicate();
        re.moveToBookmark(r.getBookmark());
        rc.setEndPoint("EndToStart", re);
        return rc.text.length;
    }
    return 0;
}

function tagTracking(type, data = false) {

    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({ ecommerce: null });

        if (typeof data === "string") {
            data = JSON.parse(data);
        }

        switch (type) {
            case "registration":
                dataLayer.push({ event: "CompleteRegistration" });
                break;
            case "authorize":
                dataLayer.push({ event: "Auth" });
                break;
            case "addToCard":
                dataLayer.push({
                    event: "add_to_cart",
                    ecommerce: {
                        items: data
                    }
                });
                break;
            case "buyNow":
                dataLayer.push({
                    event: "add_to_cart",
                    ecommerce: {
                        items: data
                    }
                });
                break;
            case "checkout":
                dataLayer.push({
                    event: "begin_checkout",
                    ecommerce: {
                        items: data
                    }
                });
                break;
            case "confirmPay":
                dataLayer.push({
                    event: "checkout_progress",
                    ecommerce: {
                        items: data
                    }
                });
                break;
            case "successPurchase":
                dataLayer.push({
                    event: "purchase",
                    ecommerce: data
                });
                break;
            case "socialAuth":
                dataLayer.push({ event: "SocialAuth" });
                break;
            case "removeFromCart":
                dataLayer.push({
                    event: "remove_from_cart",
                    ecommerce: {
                        items: data
                    }
                });
                break;
            case "viewOffers":
                dataLayer.push({
                    event: "select_item",
                    ecommerce: {
                        items: data
                    }
                });
                break;
            case "viewProducts":
                dataLayer.push({
                    event: "view_item_list",
                    ecommerce: {
                        items: data
                    }
                });
                break;
        }
    }
}





function showBookmarkNotification() {
    $(".js-bookmarks-indecator")
        .closest(".js-bookmark-item")
        .addClass("new-data");
}

function bookmarkCookie(isAdd) {
    var cookie = isNaN(parseInt(getCookie("bookmarks")))
        ? 0
        : parseInt(getCookie("bookmarks"));
    if (isAdd) {
        setCookie("bookmarks", cookie + 1);
    } else {
        cookie !== 0 ? setCookie("bookmarks", cookie - 1) : false;
        setTimeout(function () {
            if (cookie === 1) {
                $(".js-bookmarks-indecator")
                    .closest(".js-bookmark-item")
                    .removeClass("new-data");
            }
        }, 1);
    }
}

function getCookie(name) {
    var matches = document.cookie.match(
        new RegExp(
            "(?:^|; )" +
            name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
            "=([^;]*)"
        )
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, options) {
    options = options || {};

    var expires = options.expires;

    if (typeof expires == "number" && expires) {
        var d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d;
    }
    if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
    }

    value = encodeURIComponent(value);

    var updatedCookie = name + "=" + value;

    for (var propName in options) {
        updatedCookie += "; " + propName;
        var propValue = options[propName];
        if (propValue !== true) {
            updatedCookie += "=" + propValue;
        }
    }

    document.cookie = updatedCookie;
}

function miniCardCheckOnItems() {
    if ($(".js-mini-cart").find(".list-items").length !== 0) {
        $(".js-mini-cart").show();
    } else {
        $(".js-mini-cart").hide();
    }
}



// Mobile menu func
function mobileMenuFunc() {
    $(".js-header-mob-burger").on("click", function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(".js-header-mob-menu").removeClass("js-open");
        } else {
            $(this).addClass("active");
            $(".js-header-mob-menu").addClass("js-open");
        }
    });
}

function setViewedOrders(order_id) {
    let viewed_orders = JSON.parse(getCookie("viewed_orders"));
    if (viewed_orders == null) viewed_orders = [];
    let index = viewed_orders.indexOf(order_id);
    if (index == -1) {
        viewed_orders.push(order_id);
    }
    setCookie("viewed_orders", JSON.stringify(viewed_orders));
}

function notificationsHide() {
    $(".push_notification-block").fadeOut("fast");
    notificationTimerID = setTimeout(() => notificationsShow(), 5000);
}

function notificationsShow() {
    if ($(".push_notification-block").hasClass("hide")) {
        return false;
    }

    $.ajax({
        url: "/order/notifies",
        success: function (html) {
            $(".push_notification_container").html(html);
            $(".push_notification-block").fadeIn("fast");
        },
    });
}

function notificationsHideTimer() {
    notificationTimerID = setTimeout(() => notificationsHide(), 10000);
}

const toggleClassesHeader = (state, classActions) => {
    classActions.forEach(({ element, classes }) => {
        if (state) {
            classes.forEach(cls => element.addClass(cls));
        } else {
            classes.forEach(cls => element.removeClass(cls));
        }
    });
};

$(document).ready(function () {
    tabsSlider();
    initSelectmenu();
    initSpan();
    initDateRangePicker();
    showDropDownOnHover();
    initNavBarSubMenu($("#bottom_menu-collapse"));
    initShoppingCart($(".shopping-cart-page"));
    checkAlert();
    Go2Top.init();
    notificationsHideTimer();


    /*** Autocomplete ***/
    var xhr;
    var ac = function (elm) {
        var e = $(elm);
        var f = e.parents("form");
        var s = e.val().trim();

        $(".search-results").remove();

        if (s.length < 3) {
            return;
        }

        if (xhr && xhr.readyState !== 4) {
            xhr.abort();
        }

        xhr = $.ajax({
            url: f.attr("action"),
            data: { q: s },
            type: "get",
            dataType: document,
            success: function (data) {
                $(data).insertAfter(e).show();
            },
            fail: function (data) {
                console.log("failed");
            },
        });
    };

    for (var i = 0; i < btnAccordion.length; i++) {
        btnAccordion[i].addEventListener("click", function () {
            this.classList.toggle("active");
            var panel = this.nextElementSibling;
            if (panel.style.maxHeight) {
                panel.style.maxHeight = null;
            } else {
                panel.style.maxHeight = panel.scrollHeight + "px";
            }
        });
    }

    // Quick buy widget
    var $qb = $("#quick-buy-container");

    if ($qb.length) {
        $(".custom-select").customSelect2();
        $.ajax({
            type: "GET",
            url: $qb.data("src"),
            dataType: document,
            data: {},
        })
            .done(function (data) {
                $qb.html($(data));
                initDrdSelect($qb);
            })
            .fail(function (data) {
                console.log("Could not initialize game gold widget");
            });

        $qb.on("input", "input.set-nick", function () {
            $("#setNick").val($(this).val());
        });

        $qb.on("customSelect2Change", "select, input", function () {
            if (!$(this).is(".input-field")) {
                $.ajax({
                    type: "GET",
                    url: $qb.data("src"),
                    dataType: document,
                    data: $qb.find("form.select, form.input").serialize(),
                })
                    .done(function (data) {
                        $qb.html($(data));
                        $(".custom-select").customSelect2();
                    })
                    .fail(function (data) {
                        console.log("Could not update game gold widget");
                    });
            }
        });

        $qb.on("click", ".count__btn", function () {
            var v = 1,
                input = $("#qty");
            $(this).is(".down") ? (v = -1) : false;
            var val = parseInt(input.val()) + v;
            val < 0 ? (val = 0) : false;
            input.val(val).trigger("change");
        });
    }


    $.widget("custom.combobox", {
        _create: function () {
            this.wrapper = $("<span>")
                .addClass("custom-combobox")
                .insertAfter(this.element);
            this.inner = $("<span>")
                .addClass("custom-combobox__inner")
                .appendTo(this.wrapper);

            this.element.hide();
            this._createAutocomplete();
            this._createShowAllButton();
        },

        _createAutocomplete: function () {
            var selected = this.element.children(":selected"),
                value = selected.val() ? selected.text() : "",
                input = this.input;

            this.input = $("<input>")
                .appendTo(this.inner)
                .val(value)
                .attr("title", "")
                .addClass(
                    "custom-combobox-input ui-widget ui-widget-content ui-state-default ui-corner-left"
                )
                .autocomplete({
                    delay: 0,
                    minLength: 0,
                    close: function (event, ui) {
                        var select = $(event.target).parents(".custom-combobox"),
                            input = select.find(".custom-combobox-input"),
                            valLength = input.val().length;
                        valLength === 0 ? select.removeClass("open") : false;
                    },
                    open: function (event, ui) {
                        var select = $(event.target).parents(".custom-combobox"),
                            w = select.width();
                        select.addClass("open");
                        $(".ui-autocomplete").css({
                            top: "+=10",
                            left: "-=20",
                            width: w,
                        });
                    },
                    position: {
                        offset: "100 40",
                    },
                    source: $.proxy(this, "_source"),
                })
                .tooltip({
                    classes: {
                        "ui-tooltip": "ui-state-highlight",
                    },
                });

            this._on(this.input, {
                autocompleteselect: function (event, ui) {
                    ui.item.option.selected = true;
                    $(ui.item.option).prop("selected", true);
                    $(ui.item.option)
                        .closest("select")
                        .find("option")
                        .removeAttr("selected");
                    $(ui.item.option).attr("selected", "selected");
                    $(ui.item.option).closest("select").trigger("change");
                    this._trigger("select", event, {
                        item: ui.item.option,
                    });
                },
                autocompletechange: "_removeIfInvalid",
            });
        },

        _createShowAllButton: function () {
            var isDarkTheme = $(document).hasClass("dark-theme") ? "black" : "";
            var input = this.input,
                wasOpen = false,
                selectLabel =
                    $(input).parents(".ui-select").find("label").html() +
                    '<span class="ico-arrow arrow-down' +
                    isDarkTheme +
                    '"></span>';

            $("<a>")
                .attr("tabIndex", -1)
                .appendTo(this.wrapper)
                .html(selectLabel)
                .button({
                    text: true,
                })

                .removeClass("ui-corner-all")
                .addClass("custom-combobox-toggle ui-corner-right")
                .on("mousedown", function () {
                    wasOpen = input.autocomplete("widget").is(":visible");
                })
                .on("click", function () {
                    input.trigger("focus");

                    if (wasOpen) {
                        return;
                    }

                    input.autocomplete("search", "");
                });
        },

        _source: function (request, response) {
            var matcher = new RegExp(
                $.ui.autocomplete.escapeRegex(request.term),
                "i"
            );
            response(
                this.element.children("option").map(function () {
                    var text = $(this).text();
                    if (this.value && (!request.term || matcher.test(text)))
                        return {
                            label: text,
                            value: text,
                            option: this,
                        };
                })
            );
        },

        _removeIfInvalid: function (event, ui) {
            if (this.input.val() === "") {
                $(this.elements).val("");
                $(this.elements).trigger("change");
            }

            if (ui.item) {
                return;
            }

            var value = this.input.val(),
                valueLowerCase = value.toLowerCase(),
                valid = false;
            this.element.children("option").each(function () {
                if ($(this).text().toLowerCase() === valueLowerCase) {
                    this.selected = valid = true;
                    return false;
                }
            });

            if (valid) {
                return;
            }

            this.input.parents(".custom-combobox").removeClass("open");

            this.input.val("");
            this.element.val("");
            this._delay(function () {
                this.input.tooltip("close").attr("title", "");
            }, 2500);
            this.input.autocomplete("instance").term = "";
        },

        _destroy: function () {
            this.wrapper.remove();
            this.element.show();
        },
    });
    $("select.select-combox").combobox();


    if ($(".redeem-modal").length) {
        $(".redeem-modal").modal("show");
    }



    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
    });

    if ($textAreaAutoHeight.length !== 0) {
        textAreaAdjust($textAreaAutoHeight);
        $textAreaAutoHeight.on("keyup", function () {
            textAreaAdjust($(this));
        });
    }

    $hoverBlock.on("mouseenter", function () {
        var tpl = $(".message__user-details-wrap").html();
        $(this).append(tpl);
    }).on("mouseleave", function () {
        $(this).find(".message__user-details").remove();
    });

    $("img.data-fix-src").each(function () {
        if (adaptive && typeof $(this).attr("data-mobile-fix-src") !== "undefined") {
            $(this).prop("src", $(this).attr("data-mobile-fix-src"));
        } else {
            $(this).prop("src", $(this).attr("data-fix-src"));
        }
    });

    $("#quick-search")
        .on("keyup", function (e) {
            ac(this);
            return true;
        })
        .parents("form")
        .on("submit", function () {
            return false;
        });

    // Search form auto submit
    $(".content").on("change search", "#quick-search", function (e) {
        // todo: do some animation
        $(this).parents("form").trigger("submit");
    });

    // Tooltips
    $('.tooltips, [data-toggle="tooltip"]').tooltip();

    if ($.fn.select2 && $(".container select").length) {
        $.fn.select2.defaults.set("width", "100%");

        $("select:not(.no-select2,:hidden)").select2({});

        $('a[data-toggle="tab"]').on("shown.bs.tab", function (e) {
            $("select:not(.no-select2,.select2-hidden-accessible,:hidden)").select2();
        });

        $(".container select[data-ajax--url]").each(function (i, o) {
            attachAjaxSearch(o);
        });

        function attachAjaxSearch(field) {
            $(field).select2({
                allowClear: true,
                placeholder: $(this).data("placeholder")
                    ? $(this).data("placeholder")
                    : "-- Not assigned --",
                ajax: {
                    dataType: "json",
                    delay: 250,
                    data: function (params) {
                        return {
                            q: params.term, // search term
                            page: params.page,
                        };
                    },
                    processResults: function (data, params) {
                        return {
                            results: data,
                        };
                    },
                    cache: true,
                },
                minimumInputLength:
                    $(this).data("minimumInputLength") >= 0
                        ? $(this).data("minimumInputLength")
                        : 3,
            });
        }
    }

    if ($.fn.summernote && $wysiTextArea.length) {
        $wysiTextArea.summernote({
            height: 300,
            disableResizeEditor: true,
        });
    }

    if ($.fn.tagsinput && $tagsInput.length) {
        $tagsInput.tagsinput();
    }

    if ($.fn.datepicker && $datepicker.length) {
        $datepicker.datepicker({
            format: "yyyy-mm-dd",
            startDate: $(this).data("startDate") ? $(this).data("startDate") : "-40y",
            endDate: $(this).data("endDate") ? $(this).data("endDate") : "+10y",
            autoclose: true,
            weekStart: 1,
        });
    }


    if ($.fn.datetimepicker && $dateTimePicker.length) {
        $dateTimePicker.datetimepicker({
            format: "yyyy-mm-dd hh:ii:ss",
            stepping: 60,
            startDate: $(this).data("startDate") ? $(this).data("startDate") : "-40y",
            endDate: $(this).data("endDate") ? $(this).data("endDate") : "+10y",
            autoclose: true,
            weekStart: 1,
        });
    }

    /* Bookmark notification logic */
    if (getCookie("bookmarks") && parseInt(getCookie("bookmarks")) !== 0) {
        showBookmarkNotification();
    }

    if ($(".contact-list.big").length) {
        $(window).on('scroll', function (event) {
            event.preventDefault();
        });
    }

    $(".datepicker-range").attr("autocomplete", "off");

    if (!$('.page-wrap').is('.shopping-cart-page') && !$('.page-wrap').is('.checkout-page')) {

        $(document).on('click', '.cart-button', function (e) {
            e.preventDefault();
        });

        $(document).on('click', '.js-cart-button', function () {
            const isActive = $(this).toggleClass('active').hasClass('active');

            const elementsToToggle = [
                { element: $('.js-mini-cart'), classes: ['active'] },
                { element: $('.background-page'), classes: ['active'] },
                { element: $('body'), classes: ['modal-open'] }
            ];

            $('.search-result').removeClass('active');
            $('.js-bookmarks-url').removeClass('active');
            $('.js-header-category-desc').removeClass('active');

            $('.js-bookmark-mini').removeClass('active');
            $('.js-category').removeClass('active');

            $('.js-remove-bookmark').removeClass('active');

            toggleClassesHeader(isActive, elementsToToggle);

        });
    }

    if ($(window).width() < 1200) {
        $footerPaymentsSlider.slick({
            infinite: true,
            slidesToShow: 10,
            centerMode: true,
            slidesToScroll: 'auto',
            swipeToSlide: false,
            arrows: false,
            variableWidth: true,
            autoplay: true,
            autoplaySpeed: 1,
            speed: 5000,
            cssEase: 'linear',
            draggable: false,
            waitForAnimate: false,
            pauseOnFocus: true,
            pauseOnHover: true,
        });
    }

    $(".js-header-category-desc").on('click', function(e) {
        e.preventDefault();

        const isActive = $(this).toggleClass('active').hasClass('active');

        $('.search-result').removeClass('active');
        $('.js-bookmarks-url').removeClass('active');
        $('.js-bookmark-mini').removeClass('active');
        $('.js-filter-search-desc').removeClass('active');
        $('.header-search__fiters-wrap').removeClass('active');
        $('.js-mini-cart').removeClass('active');
        $('.js-filter-search-desc').removeClass('active');
        $('.js-remove-bookmark').removeClass('active');

        const elementsToToggle = [
            { element: $('.js-category'), classes: ['active'] },
            { element: $('.background-page'), classes: ['active'] },
            { element: $('body'), classes: ['modal-open'] }
        ];

        toggleClassesHeader(isActive, elementsToToggle);

    });

    $(document).on('click', '.js-bookmark-item .header-inner__nav-container', function(e) {
        e.preventDefault();
    });

    $(document).on("click", ".js-bookmarks-url", function () {
        const isActive = $(this).toggleClass('active').hasClass('active');

        const lang = $('html').attr('lang');

        const elementsToToggle = [
            { element: $('.js-bookmark-mini'), classes: ['active'] },
            { element: $('.background-page'), classes: ['active'] },
            { element: $('body'), classes: ['modal-open'] }
        ];

        $('.search-result').removeClass('active');
        $('.js-category').removeClass('active');
        $('.js-header-category-desc').removeClass('active');
        $('.js-bookmark-mini').removeClass('active');
        $('.js-cart-button').removeClass('active');
        $('.js-mini-cart').removeClass('active');
        $('.js-filter-search-desc').removeClass('active');
        $('.header-search__fiters-wrap').removeClass('active');

        toggleClassesHeader(isActive, elementsToToggle);


        $.ajax({
            url: `/${lang}/bookmark/ajax-update`,
            success: function (data) {
                $('.js-bookmark-mini').html(data);
            },
        });

    });

    $(document).on('click', '.js-remove-bookmark', function() {
        $(this).removeClass('active');
        $('.js-bookmark-mini').removeClass('active');
        $('body').removeClass('modal-open');
        $('.background-page').removeClass('active');
    })

     $('.js-header-search-mob').slideUp(500);
});

$('html').on('click', '.button--link-to-chat, .mobileChat', function (e) {
    e.preventDefault();
    const href = $(this).attr('href');
    const urlParams = new URL(href, window.location.origin).searchParams;

    const userId = urlParams.get('userIdTarget');
    const newPage = urlParams.has('newPage');

    if (userId && typeof window.prepareOpenModalChat === 'function') {
        window.prepareOpenModalChat(userId, newPage);
    } else if (href) {
        window.location.href = href;
    }
});

$(document).on("pjax:complete", function (event) {
    tabsSlider();
    initSelectmenu();
    initSpan();
    initDateRangePicker();
    $(".custom-select").customSelect2();
    $(document).lazyLoadXT();
});

// header events
$(document).on("click", ".js-mini-cart-moby .js-close", function () {
    $(".js-mini-cart-moby").removeClass("js-show");
});

$(document).on("click", ".js-card-moby-open", function () {
    $(".js-mini-cart-moby").addClass("js-show");
});

$(document).on("click", ".js-mob-search-form-open", function () {
    $(".js-header-search-form").addClass("js-show");
});

$(document).on("click", ".js-mobile-search-close", function () {
    $(".js-header-search-form").removeClass("js-show");

    if ($(".js-header-search-form .form-control").val().length === 0) {
        $(".search-result").removeClass('active');
    }
});
// header events end

$(document).on("submit", "form.need-selection", function () {
    if ($(this).find(".selection:checked").length == 0) {
        alert("Nothing selected.");
        return false;
    }
});


$(document).on('click', "#toggle-btn", function () {
    $(this).toggleClass("active");
    $("#overlay").toggleClass("open");
});
$(document).on('click', ".overlay-menu a", function () {
    $("#overlay").toggleClass("open");
    $("#toggle-btn").toggleClass("active");
});

$(document).on("change", "#info__notifications .datepicker-range, #reflink-index-form .datepicker-range, #user-statistic .datepicker-range-second", function (ev, picker) {
    $(this).parents("form").submit();
});

$(document).on("click", ".view-block a", function (e) {
    e.stopPropagation();
});

$(document).on("click", ".prevent-default", function (e) {
    e.preventDefault();
    e.stopPropagation();
});

$(document).on("successRender.daterangepicker", ".datepicker-range, .datepicker-range-second", function (ev, picker) {
    $(".monthselect").customSelect2();
    $(".yearselect").customSelect2();
});

var headerInput = $("header #search input[name=name]"),
    timeOut;
headerInput.on("keyup", function () {
    clearTimeout(timeOut);
    timeOut = setTimeout(requestForSearchHeaderInput, 200, $(this));
});

headerInput.on("keydown", function () {
    clearTimeout(timeOut);
});


$(document).on('mouseup', function (e) {
    var alphabetWrap = $(".alphabet-wrap");

    if (!alphabetWrap.is(e.target) && alphabetWrap.has(e.target).length === 0) {
        $(".alphabet-wrap .dropdown-content").hide();
        $(".alphabet-wrap .dropdown .dropbtn").removeClass("active");
    }
});

$(document).on("input change", ".category-page #search-in-category input[name=name],header #search input[name=name]", function () {
    var val = $(this).val();
    val = val.replace(/^\s+/g, "");
    val = val.replace(/\s{2,}/g, " ");
    $(this).val(val);
});

$(document).on("change keyup input click", "input.just-numb", function () {
    if (this.value.match(/[^0-9]/g)) {
        this.value = this.value.replace(/[^0-9]/g, "");
    }
});

$(document).on("click", ".tabs .slick-list .tab", function () {
    $(this).parents(".slick-list").find(".tab").removeClass("active");
});

$(document).on("click", "*[data-tag-tracking]", function () {
    tagTracking($(this).attr("data-tag-tracking"), $(this).attr("data-info"));
});

$(document).on("click", ".socials-list .socials a", function () {
    tagTracking("socialAuth");
});

$(document).on('click', '.offers-wrap .offers-title', function () {
    var isActive = $(this).closest('.offers-wrap').hasClass('active')
    if (!isActive) {
        $('.offers-wrap .offers-list').slideDown();
        $('.offers-wrap').addClass('active');
    } else {
        $('.offers-wrap .offers-list').slideUp();
        $('.offers-wrap').removeClass('active');
    }
});

$(document).on("click", ".copy-button", function () {
    CopyToClipboard($(this).attr("data-copy-id"));
    $(this).find(".informer").css("opacity", 1);
    $(this).find(".informer").animate(
        {
            opacity: 0,
        },
        1000
    );
});

// Notifications
$(document).on("click", "a.notification", function () {
    var $elm = $(this);
    $.ajax({
        url: $(this).data("url"),
        type: "post",
        data: yii.getCsrfParam() + "=" + yii.getCsrfToken(),
        success: function (data) {
            $elm.removeClass("bold");
            var l = $(".active .notification.bold").length;
            var b = $(".nav-tabs li.active .badge");
            if (b) {
                if (l) {
                    b.text("" + l);
                } else {
                    b.remove();
                }
            }
        },
        error: function (request, status, error) {
            alert("Error: Could not mark notification as read.");
        },
    });
});

$(document).on("click", "a.delete-notification", function () {
    var $elm = $(this);
    $.ajax({
        url: $(this).data("url"),
        type: "post",
        data: yii.getCsrfParam() + "=" + yii.getCsrfToken(),
        success: function (data) {
            $elm.parents("tr").fadeOut(300, function () {
                $(this).remove();
                var l = $(".active .notification.bold").length;
                var b = $(".nav-tabs li.active .badge");
                if (b) {
                    if (l) {
                        b.text("" + l);
                    } else {
                        b.remove();
                    }
                }
            });
        },
        error: function (request, status, error) {
            alert("Error: Could not delete notification.");
        },
    });
});







$(document).on("click", ".bookmark-toggle", function (event) {
    event.preventDefault();
    var url = $(this);
    var div = url.find("div");
    var isActive = div.hasClass("active") || url.hasClass("active");

    $.ajax({
        url: url.attr("href"),
        type: "get",
        success: function (data) {
            const href = url.attr("href");
            const params = new URLSearchParams(href.split('?')[1]);
            let bookmarkId = params.get('offer_id');
            if (bookmarkId === null) bookmarkId = params.get('product_id');
            window.dispatchEvent(new CustomEvent('updateVueBookmark', { detail: { itemId: bookmarkId } }));
            let countInfo = $(".js-bookmarks-indecator")
                .closest(".js-bookmark-item:visible")
                .find(".js-count-informer");
            let cnt = parseInt(countInfo.text());
            if (isNaN(cnt)) {
                cnt = 0;
            }
            if (isActive) {
                countInfo.text(--cnt);
                bookmarkCookie(false);
                if(cnt == 0) {
                    $('.header-inner__nav-item--bookmarks .header-inner__nav-container').removeClass('js-bookmarks-url');
                    $('.header-inner__nav-item--bookmarks .header-inner__nav-container').addClass('js-remove-bookmark');
                }
            } else {
                $('.header-inner__nav-item--bookmarks .header-inner__nav-container').removeClass('js-remove-bookmark').addClass('js-bookmarks-url');
                countInfo.text(++cnt);
                showBookmarkNotification();
                bookmarkCookie(true);
            }
            if (cnt == 0) {
                //$('.header-inner__nav-item--bookmarks .header-inner__nav-container').removeClass('js-bookmarks-url');
                $(".js-bookmarks-indecator")
                    .closest(".js-bookmark-item:visible")
                    .removeClass("view-informer");
                    // $('.header-inner__nav-container').removeClass('active');
                    // $('.js-bookmark-mini').removeClass('active');
                    // $('.background-page').removeClass('active');
                    // $('body').removeClass('modal-open');
            } else {
                $(".js-bookmarks-indecator")
                    .closest(".js-bookmark-item:visible")
                    .addClass("view-informer");
            }
            div.toggleClass("active");
            if ($("#products-pjax:visible").length) {
                $.pjax.reload({
                    container: "#products-pjax",
                    timeout: false,
                });
            }
            if ($("#offers-pjax:visible").length) {
                $.pjax.reload({
                    container: "#offers-pjax",
                    timeout: false,
                });
            }
        },
    });
    return false;
});

$(document).on('click', '.js-bookmark-mini .bookmark-toggle', function(){
    if($(this).hasClass('active')) {
        $(this).removeClass('active');
    }else {
        $(this).addClass('active');
    }
});

$(document).on("change", "input[type=text].autosubmit", function () {
    $(this).parents("form:first").submit();
});

$(document).on("click", "input[type=radio].autosubmit", function () {
    $(this).parents("form:first").submit();
});

$(document).on(
    "apply.daterangepicker",
    ".datepicker-range.autosubmit",
    function () {
        $(this).parents("form:first").submit();
    }
);

$(document).on(
    "change",
    ".hasDatepicker.autosubmit, input[type=text].autosubmit",
    function () {
        $(this).parents("form:first").submit();
    }
);

$(document).on("customSelect2Change", ".custom-select.autosubmit", function () {
    $(this).parents("form:first").submit();
});



















$(document).on('change', '#footer-modal select[name="region_id"]', function () {
    window.location.href = '?region_id=' + $(this).val();
});

$(document).on('click', '#footer-modal .js-btn-preloader-gray-onClick', function () {
    $(this).addClass('load');
    setTimeout(() => { $(this).removeClass('load'); }, 3000)
});

$(document).on("click", ".js-show-notifications", function (e) {
    e.preventDefault();
    if (!$(this).is(".active")) {
        $(".js-notifications-list").show();
        $(".js-notifications-list").addClass("active");
        $(this).addClass("active");
    } else {
        $(".js-notifications-list").hide();
        $(".js-notifications-list").removeClass("active");
        $(this).removeClass("active");
    }
});

// $(document).on("mouseenter", "header .notification-wrap .notification", function () {
//
//     var element = this;
//     if ($(element).is(".unread")) {
//         $.ajax({
//             url:
//                 $("header .notification-wrap").attr("data-url") +
//                 "/" +
//                 $(element).attr("data-id"),
//             success: function (data) {
//                 if (data["success"] == 1) {
//                     $(element).removeClass("unread");
//                     $(element).addClass("read");
//                     $(".showerNotifications .count-informer").html(
//                         data["count_unread"]
//                     );
//                     if (data["count_unread"] < 1) {
//                         $(element)
//                             .parents(".js-notifications-item")
//                             .removeClass("view-informer");
//                     }
//                 }
//             },
//         });
//     }
// });

$(document).on("click", "button", function () {
    if (!$(this).is(".slick-arrow") && !$(this).is(".switch-disabled")) {
        var button = this;
        setTimeout(function () {
            if ($(button).closest('#form-signup').length && $('#agree_terms').length && !$('#agree_terms').is(':checked')) {
                let fields = ["username", "email", "country_id", "currency_id", "password", "confirm_password"];
                fields.forEach(function (item) {
                    $("#form-signup").yiiActiveForm("validateAttribute", "signupform-" + item);
                });
            }
            $(button).prop("disabled", true);
        }, 1);
        setTimeout(function () {
            $(button).prop("disabled", false);
        }, 2000);
    }
});

$(document).on("click", ".mini-cart .down, .mini-cart .up, .mini-cart .delete-icon, #cardModal .down, #cardModal .up, #cardModal .delete-icon, .mini-cart-moby .down, .mini-cart-moby .up, .mini-cart-moby .delete-icon, checkout_delete .delete-icon", function () {
    var count = $(this).parents(".js-card-count-container").find(".count");
    var itemId = parseInt(
        $(this)
            .parents(".js-card-count-container")
            .find(".count-row")
            .attr("data-item")
    );
    let qtt = parseInt($(count).val(), 10);
        
    if ($(this).is(".up")) {
        count.val(qtt + 1);
    } else {
        count.val(qtt - 1);
    }

    if ($(this).is(".delete-icon")) {
        count.val((qtt = 0));
    }

    let countSum = count.val();

    count.val(countSum);

    window.updateMiniCarts(countSum, itemId);
});

$(document).on("click", "button.confirm-delivery", function () {
    $(".confirm-delivery-item .itemId").val($(this).attr("data-item-id"));
    $(".confirm-delivery-item .id").val($(this).attr("data-id"));
});

$(document).on("click", ".js-confirm-delivery", function () {
    $(".confirm-delivery-item .itemId").val($(this).attr("data-item-id"));
    $(".confirm-delivery-item .id").val($(this).attr("data-id"));
});

// $(document).on("click", ".drop-list", function (event) {
//     event.preventDefault();
//     if ($(this).hasClass("active")) {
//         $(".drop-list").removeClass("active");
//         $(".wrap-menu-drops").slideUp("slow");
//     } else {
//         $(".drop-list").removeClass("active");
//         $(".wrap-menu-drops").slideUp("slow");
//         $(this).addClass("active");
//         let attrId = "#" + $(this).attr("data-name");
//         $(attrId).slideDown("slow");
//     }
// });



//Push notifications
$(document).on("click", ".push_notification_close", function () {
    $(this).closest(".push_notification-block").fadeOut();
    if ($(".push_notification").data("id") != null) {
        setViewedOrders($(".push_notification").data("id"));
    }
    clearTimeout(notificationTimerID);
});

$(document).on("mouseover", ".push_notification", function () {
    clearTimeout(notificationTimerID);
    notificationsHideTimer();
});

$(document).on("pjax", function () {
    mobileMenuFunc();
    miniCardCheckOnItems();
});

window.addEventListener("load", () => {
    mobileMenuFunc();
    miniCardCheckOnItems();
});

if (adaptive) {
    $(document).on('click', '.footer-inner__card-title', function () {
        var $menuTitle = $(this);
        var $menuWrap = $menuTitle.closest('.footer-inner__card');
        var $menuList = $menuWrap.find('.footer-inner__card-list');
        $menuTitle.css('pointer-events', 'none');
        setTimeout(() => { $menuTitle.css('pointer-events', 'all') }, 500);

        $menuTitle.toggleClass('active');
        $menuList.slideToggle(500).toggleClass('active', $menuList.is(':visible'));
    });
}

$(document).on('click', function (event) {
    const $target = $(event.target);
    const isDropdownParent = $target.closest('.js-custom-dropdown-parent').length;
    const isDropdown = $target.hasClass('js-custom-dropdown');

    if (!isDropdownParent && !isDropdown) {
        const dropdownParent = $('.js-custom-dropdown-parent');
        const dropdown = $('.js-custom-dropdown');
        const dropdownMenu = $('.js-custom-dropdown-menu');

        if (dropdown.hasClass('js-drop-with-bg-wrap')) {
            if ($(window).width() > 768) {
                $('.background-wrapper--custom-dropdown').removeClass('active');
            }
        }
        $('.header-user-block__list-item').removeClass('active');
        dropdown.removeClass('active');
        dropdownMenu.removeClass('open');
        dropdownParent.removeClass('open');
        dropdownMenu.slideUp(300);
    }
});

$(document).on('click', '.js-custom-dropdown', function () {
    const $this = $(this);
    const dropdownParent = $this.parents('.js-custom-dropdown-parent');
    const dropdownMenu = dropdownParent.find('.js-custom-dropdown-menu');

    if ($this.hasClass('active')) {
        if ($this.hasClass('js-drop-with-bg-wrap')) {
            $('.background-wrapper--custom-dropdown').removeClass('active');
        }
        $this.removeClass('active');
        dropdownMenu.removeClass('open');
        dropdownParent.removeClass('open');
        dropdownMenu.closest('.header-user-block__list-item').removeClass('active');
        dropdownMenu.slideUp(300);
    } else {
        const otherDropdown = $('.js-custom-dropdown.active');
        const otherDropdownParent = otherDropdown.parents('.js-custom-dropdown-parent');
        const otherDropdownMenu = otherDropdownParent.find('.js-custom-dropdown-menu');

        otherDropdown.removeClass('active');
        otherDropdownMenu.removeClass('open');
        otherDropdownParent.removeClass('open');
        otherDropdownMenu.closest('.header-user-block__list-item').removeClass('active');
        otherDropdownMenu.slideUp(300);

        if (dropdownMenu.length > 0) {
            if ($this.hasClass('js-drop-with-bg-wrap')) {
                if ($(window).width() > 768) {
                    $('.background-wrapper--custom-dropdown').addClass('active');
                }
            }

            dropdownMenu.closest('.header-user-block__list-item').addClass('active');
            $this.addClass('active');
            dropdownParent.addClass('open');
            dropdownMenu.slideDown(300);
        }
    }
});


$(document).on('click', '.js-filters-search-desc', function(e) {
  const $this = $(e.currentTarget);
  const getTextFiltersCategory = $this.find('span').text();
  const getIdCategory = $this.closest('li').attr('data-category');

  let $container = $this.closest('.header-search__wrap').find('.header-search__wrap--group .header-search__filter-chips');

  if ($container.length === 0) {
    $container = $('<div/>', {"class": "header-search__filter-chips"});
    $this.closest('.header-search__wrap').find('.header-search__wrap--group').append($container);
  }

  $container.empty();

  const createChipsInner = $(`
    <span class="header-search__filter-chips-name" data-category-search="${getIdCategory}">${getTextFiltersCategory}</span>
    <button class="header-search__filter-chips-remove js-remove-chips" type="button"></button>
  `);

  $container.append(createChipsInner);

  const getWidth = createChipsInner.outerWidth();

  if(adaptive) {
    $('.header-search__field input').css('width', `calc(100% - ${parseInt(getWidth) + 15}px)`);
  }
  $('.header-search__fiters-wrap').removeClass('active');
  $('.js-filter-search-desc').removeClass('active');
  $('body').removeClass('modal-open');
  $('.background-page').removeClass('active');
});

$(document).on('click', '.js-remove-chips', (e) => {
    const $this = $(e.currentTarget);
    $('.js-header-search-filter-mob').removeClass('active');

    if(adaptive) {
        $('.header-search__field input').css('width', '100%');
    }
    $this.parent().remove();
});

$(document).on('click', '.js-header-search-filter-mob', function(){
  $(this).toggleClass('active');
  $('.search-result').removeClass('active');
  $('.js-category-mob').removeClass('active');
  $('.js-header-category-mob').removeClass('active');
  if($(this).hasClass('active')) {
    $('.js-filters-mobile').addClass('active');
  }else {
    $('.js-filters-mobile').removeClass('active');
  }

});

$(document).on('click', '.js-open-search-mobile', (e) => {
  const $this = $(e.currentTarget);

  $this.toggleClass('active');
  $('.js-open-sidebar-btn-mob').removeClass('active');
  $('.js-user-menu').removeClass('active');

  if($this.hasClass('active')) {
    $('body').addClass('modal-open');
    $('.background-page').addClass('active');
    $('.js-header-search-mob').slideDown(500);
  }else {
    $('.js-header-category-mob').removeClass('active');
    $('.js-header-search-filter-mob').removeClass('active');
    $('.background-page').removeClass('active');
    $('.js-header-search-mob').slideUp(500);
    $('.js-category-mob').removeClass('active');
    $('.search-result').removeClass('active');
    $('.js-filters-mobile').removeClass('active');
    $('body').removeClass('modal-open');
  }
});

$(document).on('click', '.js-header-category-mob', function(){
  const $this = $(this);
  $this.toggleClass('active');
  $('.js-header-search-filter-mob').removeClass('active');
  $('.js-filters-mobile').removeClass('active');
  $('.search-result').removeClass('active');
  if ($this.hasClass('active')) {
      $('.js-category-mob').addClass('active');
  } else {
    $('.js-category-mob').removeClass('active');
  }

});

$(document).on('click', '.copy-teams', function() {
    const $el = $(this);
    let tempElement = $('<textarea>');

    renderAlert($el.data('text'), 'success', 3000);

    $('body').append(tempElement);
    tempElement.val($el.data('mail')).select();
    document.execCommand('copy');
    tempElement.remove();
});
